module.exports = __webpack_public_path__ + "static/media/Francesco_Simplicio.b9284497.png";